export const getLineCount = (str: string, maxCharsPerLine: number): number => {
  if (str.length === 0) {
    return 1;
  }

  return Math.ceil(str.length / maxCharsPerLine);
};

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isEmailValid = (email: string): boolean => emailRegex.test(email);

export const stringToColor = (string: string): string => {
  let hash = 0;
  let i : number;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const capitalize = (string : string, options = {allWords: false}) : string | null => {
  const {allWords = false} = options;
  if (string) {
    if (allWords) return string.split(' ').map(word => capitalize(word)).join(' ');
    return string.substring(0, 1).toUpperCase() + string.substring(1);
  }
  return null;
}